var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"figure-container col-2",class:( _obj = {}, _obj[_vm.color] = true, _obj )},_vm._l((_vm.color == 'whites' ? _vm.deletedWhites : _vm.deletedBlacks),function(figure){return _c('div',{key:figure['.key'],staticClass:"figure",class:_vm.getFigureCss(figure['.value'])})}))
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f8f1c8b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeletedFigures.vue
// module id = null
// module chunks = 